import { render, staticRenderFns } from "./ottr.vue?vue&type=template&id=8c78c8c4&scoped=true&"
import script from "./ottr.vue?vue&type=script&lang=js&"
export * from "./ottr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c78c8c4",
  null
  
)

export default component.exports